import type { PageSlug } from "@storytell/core";
import type { TranslationKey } from "~/i18n/translations";

const APP_NAME = "Chief";

/**
 * The name each page slug shows in the browser tab. Hand-maintained, and not
 * always the page's own heading key — the Library page heading renders
 * `project_homepage.library` while its tab reads "Files", and Project Memories
 * and Search differ too, so check the page before adding a slug. Slugs the nav
 * bar and the command palette don't offer as a page are `null` here and fall
 * back to the app name; every slug needs an entry, so a new one added in
 * `@storytell/core` fails `ts-check` until it gets a name or a `null`.
 */
const PAGE_SLUG_TITLE_KEYS: Record<PageSlug, TranslationKey | null> = {
  assets: "entity.project_files",
  concepts: "entity.project_concepts",
  labels: "entity.project_labels",
  collections: "entity.project_collections",
  skills: "skills.page_title",
  personas: "personas.page_title",
  actions: "actions.title",
  chats: "nav_chats",
  search: "nav_search_chat_titles",
  memories: "memory.title",
  "live-sessions": "live_sessions.title",
  "new-collection": null,
  "scope-picker": null,
  record: null,
  "command-center": null,
};

/** `document.title` for a page slug route, e.g. "Live Sessions | Chief". */
export const pageSlugDocumentTitle = (slug: PageSlug, t: (key: TranslationKey) => string): string => {
  const key = PAGE_SLUG_TITLE_KEYS[slug];
  return key ? `${t(key)} | ${APP_NAME}` : APP_NAME;
};
